import { api, loadRazorpay } from "@/lib/api";
import { toast } from "sonner";

// Handles registration + payment for both passes.
// onSuccess(registrationId) is called after payment/mock succeeds.
export async function startPayment({ payload, onSuccess, setLoading }) {
  try {
    setLoading(true);
    const { data } = await api.post("/registrations", payload);
    const { registration_id, order_id, key_id, amount, prefill, mock } = data;

    // No online order (mock mode or free) -> confirm directly
    if (!order_id) {
      await api.post("/payments/mock-confirm", { registration_id });
      setLoading(false);
      onSuccess(registration_id, amount);
      return;
    }

    const ok = await loadRazorpay();
    if (!ok) {
      setLoading(false);
      toast.error("Could not load payment gateway. Check your connection.");
      return;
    }

    const rzp = new window.Razorpay({
      key: key_id,
      amount: amount * 100,
      currency: "INR",
      name: "Meraki Moto Mania",
      description: payload.pass_type === "day" ? "Day Pass Registration" : "Meraki Pass Registration",
      order_id,
      prefill,
      theme: { color: "#FF4500" },
      handler: async (resp) => {
        try {
          await api.post("/payments/verify", {
            registration_id,
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          onSuccess(registration_id, amount);
        } catch (e) {
          toast.error("Payment verification failed. Please contact support.");
        }
      },
      modal: {
        ondismiss: () => setLoading(false),
      },
    });
    rzp.on("payment.failed", () => {
      setLoading(false);
      toast.error("Payment failed. Please try again.");
    });
    setLoading(false);
    rzp.open();
  } catch (e) {
    setLoading(false);
    const detail = e?.response?.data?.detail;
    toast.error(typeof detail === "string" ? detail : "Something went wrong. Please try again.");
  }
}
